<template>
  <div class="note-dropdown" :class="{ active: active }">
    <div class="header" :class="{ active: active }">
      <div class="item left">
        <div
          @click="
            active = !active
            $emit('turn')
          "
        >
          {{ title }}
        </div>
        <div class="ml-2 cursor-pointer d-flex">
          <slot name="buttons-left"></slot>
        </div>
      </div>
      <div class="item right">
        <div class="cursor-pointer d-flex">
          <slot name="buttons-right"></slot>
        </div>
        <i class="bx bx-chevron-down ml-2 arrow" @click="active = !active"></i>
      </div>
    </div>
    <div class="contentt" :class="{ active: active }">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'note-dropdown',

  props: {
    title: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      active: false,
    }
  },
}
</script>

<style scoped></style>
